const initialState =  {
    alertsearch: {},
    fetching: false,
};

export default function alertsearch(state = initialState, action) {
    switch (action.type) {
        case 'GET_ALERTSEARCH_SUCCESS':
            return { ...state, alertsearch: action.payload, fetching: false };
        default:
            return state
    }
}
